import "core-js/modules/es.array.push.js";
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-02fa976a"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "launch-faq"
};
const _hoisted_2 = {
  class: "launch-faq-title"
};
const _hoisted_3 = {
  class: "launch-faq-body"
};
const _hoisted_4 = ["onClick"];
const _hoisted_5 = {
  class: "launchpad-faq-item-title"
};
const _hoisted_6 = {
  class: "launchpad-faq-item-title-text"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "launchpad-faq-item-title-icon"
}, null, -1));
const _hoisted_8 = ["innerHTML", "onClick"];
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { toLogin } from '@/utils/jumpLink';
import { saPushEvent } from '@/utils/sensors';
import { replaceDomainToLocation } from '@/utils/url';
import TextLink from '@/components/text-link';
import { useInvitation } from '../hooks/useInvitation';
export default {
  __name: 'HomeFAQ',
  props: {
    overviewData: {
      type: Object,
      default: null
    }
  },
  setup(__props) {
    const {
      t,
      locale
    } = useI18n();
    const store = useStore();
    const invitation = useInvitation();
    const userstate = computed(() => store.state.user.userstate);
    const router = useRouter();
    const currentIdx = ref();
    const reportAction = btnName => {
      saPushEvent('SpotLpadHomePageHeadingClick', {
        page_name: 'LpadHomePage',
        plate_area: 'Heading',
        button_name: btnName
      });
    };
    const goFaq = () => {
      window.open(replaceDomainToLocation('https://www.bybit.com/en/help-center/topic-list/spot-x#launchpad'));
    };
    const goUsercenter = () => {
      reportAction('UserCenter');
      if (userstate.value !== 1) {
        toLogin(window.location.href);
      } else {
        router.push(`/${locale.value}/trade/spot/launchpad-order`);
      }
    };
    const changeIdx = newIdx => {
      if (currentIdx.value !== newIdx) {
        currentIdx.value = newIdx;
        return;
      }
      currentIdx.value = null;
    };
    const faqList = [{
      label: t('whoIsEligible'),
      content: `${t('eligibleForLaunchpad', {
        link1: replaceDomainToLocation('https://www.bybit.com/en/help-center/article/Service-Restricted-Countries'),
        link2: replaceDomainToLocation('https://www.bybit.com/user/accounts/auth/personal')
      })}\n${t('eeaCustomerParticipationProhibited')}`,
      click: () => {
        // todo 两个按钮
        // window.open('https://www.bybit.com/user/accounts/auth/personal');
      }
    }, {
      label: t('snapshotBalancesCounted'),
      content: t('fundingAndDerivativesAc'),
      click: () => {}
    }, {
      label: t('subscriptionPeriodCalc'),
      content: t('finalTokenAllocation', {
        link: ''
      }),
      click: () => {}
    }, {
      label: t('lotteryDrawDefinition'),
      content: t('lotteryTicketsAllocation'),
      click: () => {}
    }];
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, _toDisplayString(_unref(t)('lpn_faq')), 1), _createElementVNode("div", _hoisted_3, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(faqList, (item, idx) => {
        return _createElementVNode("div", {
          class: _normalizeClass(currentIdx.value === idx ? 'launch-faq-item launch-faq-item-active' : 'launch-faq-item'),
          key: idx,
          onClick: $event => changeIdx(idx)
        }, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, _toDisplayString(item.label), 1), _hoisted_7]), _createElementVNode("div", {
          class: "launchpad-faq-item-info",
          innerHTML: item.content,
          onClick: _withModifiers(item.click, ["stop"])
        }, null, 8, _hoisted_8)], 10, _hoisted_4);
      }), 64))]), _createVNode(_unref(TextLink), {
        text: _unref(t)('lpn_expand_more'),
        "cls-name": "launch-faq-more",
        onClick: goFaq
      }, null, 8, ["text"])]);
    };
  }
};